module.exports = "/build/admin/images/apple-touch-icon-72x72.099156c5.png";